import packageJson from '../package.json';

// ----------------------------------------------------------------------

export const CONFIG = {
  appName: 'Q-Hub',
  appVersion: packageJson.version,
  assetsDir: '',
};
